import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  background-color: ${({ theme }) => theme.neutral.white};
  h1 {
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
  }
  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
    @media only screen and (max-width: 800px) {
      overflow-x: auto !important;
    }
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.valueTabs !== 0 ? "1fr 1fr" : "1fr 2fr 1fr"};
  user-select: none;
  margin-left: 1.5rem;
  align-items: center;
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media only screen and (max-width: 1079px) {
      justify-content: ${(props) =>
    props.valueTabs !== 0 ? "flex-end" : "flex-start"};
    }
  }
  .table-action {
    margin-right: 20px;
    display: flex;
  }
  @media only screen and (min-width: 1075px) and (max-width: 1220px) {
    grid-template-columns: ${(props) =>
    props.valueTabs !== 0 ? "1fr 1fr" : "auto 22em 1fr"};
  }
  @media only screen and (min-width: 769px) and (max-width: 1079px) {
    grid-template-columns: 1fr auto;
  }
  @media only screen and (max-width: 769px) {
    grid-template-columns: 1fr;
  }
  .survey-approvalbtn-container {
    @media only screen and (max-width: 769px) {
      width: auto;
    }
  }
`;

export const TableViewButton = styled.div`
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .list-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const ContentModalInfo = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
`;

export const CloseModalInfo = styled.div`
  height: 3em;
  width: 100%;
  text-align: end;
  padding: 1em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalInfo = styled.div`
  height: 9em;
  width: 100%;
  border: solid 1px rgba(230, 230, 230, 1);
  display: inline-flex;
  align-items: center;
  padding: 0em 75px;
  svg {
    font-size: 3em;
  }
  p {
    margin: 0 15px;
    color: ${({ theme }) => theme.neutral.black};
  }
`;

export const ButtonInfo = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const ButtonApproval = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  background-color: ${({ active }) =>
    active ? theme.button.primary : "transparent"};
  border-radius: 4px;
  margin: 1em auto;
  color: ${({ active, theme }) =>
    active ? theme.primaryColorLight : theme.button.primary};
  cursor: pointer;
  width: 8em;
  height: 3.16em;
  font-size: 13px;
  &:hover {
    ${({ active, theme }) =>
    active
      ? `background-color: ${theme.button.primaryHover};`
      : `
          box-shadow: ${theme.button.buttonHoverShadow};
          transform: translateY(-1px);
        `}
  }
`;

export const SearchField = styled.div`
  margin-right: 0.5rem;
  width: 240px;
  height: 40px;
  position: relative;
  background: ${({ theme }) => theme.neutral.white};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  svg {
    position: absolute;
  }
  input {
    font-size: 16px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
    margin-left: 1rem;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;

export const ActionTooltipContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  .tooltip-btn {
    width: 45px;
    height: 13px;
    background: ${({ theme }) => theme.button.primary};
    padding: 13px 40px;
    font-size: 14px;
    color: ${({ theme }) => theme.neutral.white};
    margin: 10px;
  }
  .disabled-btn {
    background: ${({ theme }) => theme.neutral.gray[700]};
  }
  label {
    font-size: 11px;
    font-weight: 400;
    line-height: 15px;
  }
  .MuiSwitch-sizeSmall {
    left: 30%;
  }
`;

export const SurveyManagementTooltip = styled.div`
  display: flex;
  align-items: center;
`;
export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.neutral.white,
  },
}));
